import apiService from '../apiService';

const AnimalService = {
  listAnimal: (params) => apiService.get('/animals', params),
  getAnimal: (id) => apiService.get(`/animals/${id}`),
  createAnimal: (data) => apiService.post('/animals', data),
  updateAnimal: (id, data) => apiService.put(`/animals/${id}`, data),
  deleteAnimal: (id) => apiService.delete(`/animals/${id}`),
};

export default AnimalService;
